/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon24Solid = forwardRef('LogoMicrosoftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11 3H3v8h8V3Z" }),
        React.createElement("path", { d: "M11 13H3v8h8v-8Z" }),
        React.createElement("path", { d: "M13 3h8v8h-8V3Z" }),
        React.createElement("path", { d: "M21 13h-8v8h8v-8Z" })));
});
